import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';


const queryclient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryclient}>
    <App />
    </QueryClientProvider>  
  </React.StrictMode>,
  document.getElementById('root')
);
